






























import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";

export default Vue.extend({
  components: {
    Modal,
  },

  props: ["modalData"],
  setup() {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      height: "47rem",
      withTopRightCloseBtn: true,
    };

    return {
      config,
    };
  },
});
